import { FC } from "react";
import { Box, Typography } from "@mui/material";
import { PatientEvents } from "../patient-events";
import { PatientEvent } from "../../../../../services/patient.service";

type Props = {
  events: PatientEvent[];
  onAddEvent: (event: PatientEvent) => void;
  onDeleteEvent: (index: number) => void;
};

/** Aba "Eventos" do modal de paciente. */
const PatientEventsTab: FC<Props> = ({ events, onAddEvent, onDeleteEvent }) => (
  <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
    <Typography variant="body2" color="textSecondary">
      Registre os eventos relacionados ao tratamento do paciente, como consultas, procedimentos e acompanhamentos.
    </Typography>
    <PatientEvents events={events} onAddEvent={onAddEvent} onDeleteEvent={onDeleteEvent} />
  </Box>
);

export default PatientEventsTab;
